import { Box, Button } from '@mui/material';
import type { SyntheticEvent } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginLogo } from '../components/LoginLogo';
import { LoginAlert } from '../features/Login/components';
import { ResetPasswordStep1, ResetPasswordStep2 } from '../features/Login';
import { useTry } from '../hooks';
import { RestClient } from '../lib';
import { ContentBox, FullScreenBackground, RightSpacer } from '../styles/LoginContainerStyle';

export function RePassword() {
  const { tryReq } = useTry();
  const navigate = useNavigate();
  const [email, setEmailData] = useState('');
  const [step, setStep] = useState(1);
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState({ email: false, code: false, password: false });

  async function handleSubmitStep1(e: SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!email.trim()) {
      setError((prev) => ({ ...prev, email: true }));
    } else {
      setError((prev) => ({ ...prev, email: false }));
      await tryReq(async () => {
        await RestClient.post('/reset-code', { email });
        setStep(2);
      });
    }
  }

  async function handleSubmitStep2(e: SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    const isCodeEmpty = !code.trim();
    const isPasswordEmpty = !password.trim();

    if (isCodeEmpty || isPasswordEmpty) {
      setError((prev) => ({
        ...prev,
        code: isCodeEmpty,
        password: isPasswordEmpty,
      }));
    } else {
      setError((prev) => ({
        ...prev,
        code: false,
        password: false,
      }));
      await tryReq(async () => {
        await RestClient.post('/reset-password', { email, code, password });
        setStep(3);
      });
    }
  }

  return (
    <>
      <LoginAlert />
      <FullScreenBackground>
        <LoginLogo />
        <RightSpacer>
          <img src="/images/icon_basic.png" alt="ProPlus" style={{ height: 40 }} />
          <ContentBox>
            {step === 1 ? (
              <ResetPasswordStep1
                email={email}
                error={error.email}
                onEmailChange={setEmailData}
                onSubmit={handleSubmitStep1}
              />
            ) : step === 2 ? (
              <ResetPasswordStep2
                email={email}
                code={code}
                password={password}
                onCodeChange={setCode}
                onPasswordChange={setPassword}
                error={{ code: error.code, password: error.password }}
                onSubmit={handleSubmitStep2}
              />
            ) : (
              <Box>
                <h2>パスワードの再設定</h2>
                <h4>パスワードの更新が完了しました。ログインページに戻ってログインしてください</h4>
                <Button onClick={() => navigate('/')}>ログインページに戻る</Button>
              </Box>
            )}
          </ContentBox>
        </RightSpacer>
      </FullScreenBackground>
    </>
  );
}
